/**
 * Theme: Hyper - Responsive Bootstrap 4 Admin Dashboard
 * Author: Coderthemes
 * Component: Dragula component
 */

import Dropzone from 'dropzone';

!(function ($) {
    'use strict';

    var FileUpload = function () {
        this.$body = $('body');
    };

    var addExtensionPreview = function (file) {
        const split = file.name.split('.');
        $(file.previewElement)
            .find('[data-dz-extension]')
            .append('.' + split[split.length - 1]);
    };
    var addDownloadButtonPreview = function (file, hash) {
        var url = '/files/' + hash;
        if (file.url !== undefined && file.url !== null) {
            url = file.url;
        }
        $(file.previewElement)
            .find('[data-dz-download]')
            .replaceWith(
                $('<a class="btn btn-link btn-lg text-muted"><i class="dripicons-download"></i></a>').attr('href', url),
            );
    };

    return (
        (FileUpload.prototype.init = function () {
            // Disable auto discovery
            Dropzone.autoDiscover = false;

            $('[data-plugin="dropzone"]').each(function (index, element) {
                const submitButton = $(element).closest('form').find('button[type="submit"]');
                const originalSubmitButtonText = submitButton.text();
                const mode = $(element).data('mode');
                var inputName = $(element).data('name');
                var actionUrl = $(element).data('action');
                var value = $(element).data('value');
                var previewContainer = $(element).data('previewsContainer');

                var opts = {
                    url: actionUrl,
                };
                if (previewContainer) {
                    opts['previewsContainer'] = previewContainer;
                }

                var uploadPreviewTemplate = $(element).data('uploadPreviewTemplate');
                if (uploadPreviewTemplate) {
                    opts['previewTemplate'] = $(uploadPreviewTemplate).html();
                }

                if (mode === 'single') {
                    opts['maxFiles'] = 1;
                }

                const instance = new Dropzone(element, {
                    ...opts,
                    ...{
                        headers: {
                            'x-csrf-token': $('meta[name="csrf-token"]').attr('content'),
                        },
                        init: function () {
                            this.on('maxfilesexceeded', function (file) {
                                this.removeAllFiles();
                                this.addFile(file);
                            });

                            this.on('addedfile', function (file) {
                                if (file.hash) {
                                    $(file.previewElement).append(
                                        $('<input />')
                                            .attr('type', 'hidden')
                                            .attr('name', inputName)
                                            .attr('value', file.hash),
                                    );
                                }
                                addExtensionPreview(file);
                                addDownloadButtonPreview(file, file.hash);
                            });

                            this.on('success', function (file, response) {
                                $(file.previewElement).append(
                                    $('<input />')
                                        .attr('type', 'hidden')
                                        .attr('name', inputName)
                                        .attr('value', response.hash),
                                );
                                addDownloadButtonPreview(file, response.hash);
                            });

                            this.on('sending', function () {
                                submitButton.prop('disabled', true);
                                submitButton.text('Bezig met bestanden uploaden..');
                            });

                            this.on('complete', function () {
                                submitButton.prop('disabled', false);
                                submitButton.text(originalSubmitButtonText);
                            });
                        },
                    },
                });

                value.forEach((item) => {
                    const filte = {
                        ...item,
                        status: Dropzone.ADDED,
                        accepted: true,
                        url: item.url,
                    };

                    instance.emit('addedfile', filte);
                    instance.emit('complete', filte);
                    instance.files.push(filte);
                });
            });
        }),
        //init fileupload
        ($.FileUpload = new FileUpload()),
        ($.FileUpload.Constructor = FileUpload)
    );
})(window.jQuery),
    //initializing FileUpload
    (function ($) {
        'use strict';
        $.FileUpload.init();
    })(window.jQuery);
